<template>
  <div>
        <NavbarHeader />
    <transition name="fade" mode="out-in">
      <router-view />
    </transition>
  </div>
</template>

<script>
import NavbarHeader from "@/components/NavbarHeader.vue";

export default {
  name: 'App',
  components: {
    NavbarHeader,
  }
}
</script>

<style>
  /* .fade-enter {
    opacity: 0;
    transform: translateX(2em);
  }

  .fade-enter-active, .fade-leave-active {
    transition: all .3s ease;
  } */
</style>

<style>
  .fade-enter {
    opacity: 0;
    transform: translateX(2em);
  }
  
  .fade-enter-active, .fade-leave-active {
    transition: opacity 0.3s ease-out, transform 0.3s ease;
  }

  .fade-enter-active {
    transition-delay: 0.3s;
  }

  .fade-enter, .fade-leave-to {
    opacity: 0;
    transform: translateX(-20);
  }

  .fade-enter-to, .fade-leave {
    opacity: 1;
    transform: translateX(0px);
  }

</style>

